import { Injectable, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { AbilityService } from 'ability';
import { UiStorageKey } from 'mbs-ui-shared@models';
import { UiStorageService } from 'mbs-ui-shared@services/ui-storage.service';
import { ApplicationStore } from 'mbs-ui-shared@store/application/application.store';
import { EMPTY, Observable } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApplicationStateFacade {
  private appStore = inject(ApplicationStore);
  private uiStorage = inject(UiStorageService);
  private ability = inject(AbilityService);

  public selectStorage$ = toObservable(this.appStore.storage);
  public selectStorageLoaded$ = toObservable(this.appStore.storageLoaded);
  public selectStorageLoading$ = toObservable(this.appStore.storageLoading);
  public selectStorageWhenLoaded$ = this.selectStorageLoaded$.pipe(
    filter(Boolean),
    switchMap(() => this.selectStorage$)
  );
  public selectFooterExist$ = toObservable(this.appStore.footerExist);

  getUiStorage(): Observable<Record<string, any>> {
    this.loadUiStorage();
    return this.selectStorageWhenLoaded$;
  }

  loadUiStorage(force = false): void {
    this.appStore.loadStorage(force);
  }

  setFooterExist(payload: boolean): void {
    this.appStore.setFooterExist(payload);
  }

  updateStorageSetting(key: UiStorageKey, value: any, addAuditLogRecord = false): Observable<null> {
    if (this.ability.can('read', 'SuperAdmin')) {
      return EMPTY;
    }
    return this.uiStorage.storeSetting(key, value, addAuditLogRecord).pipe(tap(() => this.appStore.setStorageSetting(key, value)));
  }

  deleteStorageItem(key: UiStorageKey): Observable<null> {
    return this.uiStorage.deleteSetting(key).pipe(tap(() => this.appStore.deleteStorageSetting(key)));
  }
}
